<template>
  <UIDialogTransition>
    <UIDialogRoot modal :visible="isVisible">
      <UIDialog center size="lg">
        <UIDialogContent>
          <div class="row g-0">
            <div
              class="col-md-6 p-4 d-flex align-items-center justify-content-center bg-primary"
            >
              <div class="text-center text-white">
                <div
                  class="flex-grow-1 d-flex justify-content-center align-items-center"
                >
                  <IconPurplemash style="width: 120px; height: 74px" />
                </div>

                <div class="my-4">I am here to log in to Purple Mash</div>

                <UIButton
                  class="border-white text-white"
                  variant="outline-primary"
                  :icon="IconLogin"
                  @click="login"
                >
                  Login to Purple Mash
                </UIButton>
              </div>
            </div>

            <div
              class="col-md-6 p-4 d-flex align-items-center justify-content-center bg-white"
            >
              <div class="text-center text-primary">
                <div
                  class="flex-grow-1 d-flex justify-content-center align-items-center"
                >
                  <IconLogo style="width: 120px; height: 74px" />
                </div>

                <div class="my-4">I am here to check out 2Simple products</div>

                <UIButton :icon="IconTick" variant="success" @click="explore">
                  Check out products
                </UIButton>
              </div>
            </div>
          </div>
        </UIDialogContent>
      </UIDialog>
    </UIDialogRoot>
  </UIDialogTransition>
</template>

<script lang="ts">
type GatekeeperCookieValueType = "explore" | "login";

export const gatekeeperCookieId = `gatekeeper_set`;
</script>

<script setup lang="ts">
import IconLogo from "@/assets/icons/2simple.svg?component";
import IconLogin from "@/assets/icons/arrow-right-on-rectangle.svg?component";
import IconPurplemash from "@/assets/icons/purplemash.svg?component";
import IconTick from "@/assets/icons/tick.svg?component";
import { defaultCookieOptions } from "@/common/default-cookie-options";
import UIButton from "@/components/UI/UIButton.vue";
import {
  UIDialog,
  UIDialogContent,
  UIDialogRoot,
} from "@/components/UI/dialog";
import UIDialogTransition from "@/components/UI/dialog/UIDialogTransition.vue";
import { useRoute } from "@/hooks/useRoute";
import { useCookies } from "@vueuse/integrations/useCookies";
import { computed, onMounted } from "vue";

const cookies = useCookies([gatekeeperCookieId]);
const route = useRoute();

const isVisible = computed<boolean>(
  () => !cookies.get<GatekeeperCookieValueType | undefined>(gatekeeperCookieId)
);

const login = () => {
  cookies.set(gatekeeperCookieId, "explore", defaultCookieOptions);
  route.navigate("/login/");
};

const explore = () => {
  cookies.set(gatekeeperCookieId, "login", defaultCookieOptions);
};

onMounted(() => {
  // check its not disabled on this page
  if (window.DisableGatekeeper) {
    explore();
  }
});
</script>
